const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'templates',
		'artCrm',
		'entity',
		'propertiesForm'
	],

	config: {
		contextClass: false
	},

	model: {
		changesGranted: false,
		lastAddressType: '',
		fieldCodeToChildren: {
			destinationAddressID: 'client',
			mediaAddressID: 'media',
			journalistAddressID: 'journalist'
		}
	},

	methods: {
		onChange: function(){
			var self = this;
			var attributes, child, childName;
			// set selected address data if addressSelector has been changed (e.g., used for tab-title)
			if((attributes = (self.model.dirtyFields.data || {}).attributes || {})){
				var addressSelectorFieldCode, lastFieldValue;
				for(addressSelectorFieldCode in self.model.addressSelectors){
					lastFieldValue = 'last_' + addressSelectorFieldCode;
					if(attributes[addressSelectorFieldCode] !== self.model[lastFieldValue]){
						childName 										= self.model.fieldCodeToChildren[addressSelectorFieldCode];
						self.model[lastFieldValue] 						= attributes[addressSelectorFieldCode];
						self.resourceData.data 							= self.resourceData.data || {};
						self.resourceData.data.children 				= self.resourceData.data.children || {};
						self.resourceData.data.children[childName] 		= self.resourceData.data.children[childName] || {};
						self.resourceData.data.children[childName].data = self.model.addressSelectors[addressSelectorFieldCode].resourceData.data || {};
					}
				}
			}
		},

		onSubmit: function(response){
			return getComponent('artCrmController').showEdit(
				'trip',
				(response.data || {}).attributes[(response.data || {}).primaryKey || 'id'],
				((((this.resourceData.data || {}).children || {}).client || {}).data || response.data || {}),
				true,
				this.model.recordController.model.tabStrip,
				this.model.recordController.model.tabRegisterSecret,
				false
			);
		}
	},

	hooks: {
		_attach: function($element, options){
			var self = this;
			if(utils.collectionSize(self.model.addressSelectors) <= 0){
				self.model.addressSelectors = {};
				self.find('templates_artCrm_trip_fields_addressSelector', function(addressSelector){
					self.model.addressSelectors[addressSelector.model.fieldCode] = addressSelector;
				});
			}
		}
	}
}